/**
 * Fiscal calendar helpers (frontend mirror of the quarter derivation in
 * src/services/RevenueTargetService.ts). Quarters end in the months
 * three, six, nine and twelve months after the financial year starts.
 */

/** Month the financial year starts in when nothing is configured */
export const DEFAULT_FISCAL_YEAR_START_MONTH = 3;

export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
] as const;

const SHORT_MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
] as const;

/** The four 1-based months a fiscal quarter can end in, in calendar order */
export function quarterEndMonths(fiscalYearStartMonth: number): number[] {
  return [2, 5, 8, 11]
    .map((offset) => ((fiscalYearStartMonth - 1 + offset) % 12) + 1)
    .sort((a, b) => a - b);
}

/** Short human list of the quarter end months, e.g. "Feb, May, Aug, Nov" */
export function quarterEndLabel(fiscalYearStartMonth: number): string {
  return quarterEndMonths(fiscalYearStartMonth)
    .map((m) => SHORT_MONTH_NAMES[m - 1])
    .join(', ');
}
